import FormElementBehaviourDropdown, { getFormElementBehaviourLabel } from "components/dropdowns/reactselect/FormElementBehaviourDropdown";
import { FormSection, RenderEditOptions } from "components/MainSectionTemplate/types";
import React from "react";
import CurrenciesSelect from "./CurrenciesSelect";
import { getUpdateInstruction, WebformFormState } from "./model";
import { AtLeastOneTranslationValueInput, TranslationValueReadonly } from "./TranslationValueInnerForm";

export const financialOfferSection = (
  webformFormState: WebformFormState,
): FormSection => ({
  key: "financialOffer",
  title: RESX.Financial.FinancialOffer,
  type: "collapsable",
  fields: [{
    key: "financialOffer",
    label: RESX.GeneralLabels.Display,
    render: () => <>{getFormElementBehaviourLabel(webformFormState.financialOffer)}</>,
    inPageEdit: {
      render: ({ value, onChange, cancel }) => <FormElementBehaviourDropdown
        options={[]}
        value={value}
        onChange={(v) => {
          onChange(v, true);
        }}
        onEsc={() => cancel()}
        config={{
          focusOnMount: true,
          openMenuOnFocus: true,
        }}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.financialOffer,
      submitChange: async (financialOffer: server.dto.FormElementBehaviors) => window.CoreApi.WebformConfiguration.UpdateDetails({
        ...getUpdateInstruction(webformFormState),
        financialOffer,
      }),
    },
  }, {
    key: "financialOfferDescription",
    label: RESX.GeneralLabels.Description,
    sublabel: RESX.Webform.DescriptionSmallLabel,
    render: () => <TranslationValueReadonly values={webformFormState.financialOfferDescription} />,
    inPageEdit: {
      render: ({ value, onChange, submit, isSaving }: RenderEditOptions<server.dto.TranslationValue[]>) => <AtLeastOneTranslationValueInput
        validatorKey="financialOfferDescription"
        submit={submit}
        onChange={onChange}
        values={value}
        isSaving={isSaving}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.financialOfferDescription,
      submitChange: (financialOfferDescription: server.dto.TranslationValue[]) => window.CoreApi.WebformConfiguration.UpdateDetails({
        ...getUpdateInstruction(webformFormState),
        financialOfferDescription,
      }),
    }
  }, {
    key: "availableCurrencies",
    isEmpty: webformFormState.availableCurrencies.length === 0,
    label: RESX.Financial.Currency,
    render: () => <>
      {webformFormState.availableCurrencies.map(currency => <div key={currency.value}>
        {currency.value.toUpperCase()} ({currency.name})
      </div>)}
    </>,
    inPageEdit: {
      render: ({ value, onChange }) => <div className="main-section-template-fields-padding">
        <CurrenciesSelect
          validatorKey="availableCurrencies"
          value={value}
          onChange={onChange}
        />
      </div>,
      fullWidth: true,
      type: "confirmOrCancelButton",
      initialValue: webformFormState.availableCurrencies,
      submitChange: (availableCurrencies: server.dto.Currency[]) => window.CoreApi.WebformConfiguration.UpdateDetails({
        ...getUpdateInstruction(webformFormState),
        availableCurrencies: availableCurrencies.map(currency => currency.value),
      }),
    }
  }]
});